import { CreateCommentRequest, DeleteCommentRequest, ViewCommentsRequest } from './comment.types';

import {
  API_HOST,
  HttpDeleteOptions,
  HttpGetOptions,
  HttpPostOptions,
  getHttpDeleteOptions,
  getHttpGetOptions,
  getHttpPostOptions
} from '../../utils/api.util';

const getEndpoint = () => `${API_HOST}/comment`;
const getSpecificEndpoint = (externalReference: string) => `${getEndpoint()}/${externalReference}`;

export const getCreateCommentRequest = (
  data: CreateCommentRequest
): [string, HttpPostOptions<CreateCommentRequest>] => [getEndpoint(), getHttpPostOptions(data)];

export const getViewCommentsRequest = (data: ViewCommentsRequest): [string, HttpGetOptions] => [
  `${getSpecificEndpoint(data.postExternalReference)}/${data.page}/${data.size}`,
  getHttpGetOptions()
];

export const getDeleteCommentRequest = (data: DeleteCommentRequest): [string, HttpDeleteOptions] => [
  getSpecificEndpoint(data.commentExternalReference),
  getHttpDeleteOptions()
];
